<script lang="ts" setup>
import { onMounted, ref } from 'vue'

import EUFlagFooter from '@/components/Icons/EUFlagFooter.vue'
import GlobeFooter from '@/components/Icons/GlobeFooter.vue'
import PolygonIcon from '@/components/Icons/PolygonIcon.vue'
import { getUrlLang } from '@/helpers/language-helper'
import { getEnv } from '@/utils/environmentService'

defineProps<{ label: string }>()

const isMenuVisible = ref(false)
const activeMenuItemIndex = ref(0)
const language = getUrlLang()
const siteUrl =`${document.location.origin}/`
const hmarketUrl=import.meta.env.VITE_URL

const regionItems = [
  {
    title: 'Hantec Markets - FSC',
    link: `${siteUrl}`,
    icon: GlobeFooter
  },
  {
    title: 'Hantec Markets - FCA',
    link: `${hmarketUrl}${language ? `${language}/?ent=hml ` : '?ent=hml'}`,
    icon: EUFlagFooter
  }
]

const showMenu = () => {
  isMenuVisible.value = !isMenuVisible.value
}

const setActiveIndex = (index: number) => {
  activeMenuItemIndex.value = index
  isMenuVisible.value = false
}

onMounted(() => {
  if (getEnv() === 'cn') {
    regionItems.pop()
  }
})
</script>

<template>
  <div class="flex items-center gap-2.5 lg:mr-0 leading-normal">
    <div>{{ label }}</div>

    <div class="relative">
      <button
        class="text-[10px] leading-normal flex lg:leading-normal lg:text-lg pl-2.5 bg-white items-center justify-between w-full lg:py-[4px] py-[5px] text-black min-w-[170px] lg:w-[318px] -tracking-[0.16px] lg:tracking-normal"
        @click="showMenu"
      >
        <div class="relative flex items-center w-full">
          <component :is="regionItems[activeMenuItemIndex].icon"></component>

          <p class="ml-[10px]">{{ regionItems[activeMenuItemIndex].title }}</p>
        </div>
        <PolygonIcon
          aria-hidden="true"
          class="w-2.5 h-2.5 lg:ms-2.5 absolute lg:right-[15px] right-[8px]"
        >
        </PolygonIcon>
      </button>
      <div
        v-if="isMenuVisible"
        class="absolute z-10 font-normal bg-white shadow-md lg:w-[318px] min-w-[170px] top-[33px]"
      >
        <ul class="px-[10px] text-sm text-gray-700">
          <li
            v-for="(item, index) in regionItems"
            :key="index"
            class="first:pt-[20px] pb-[20px] cursor-pointer"
            @click="setActiveIndex(index)"
          >
            <a :href="item.link" class="block hover:bg-gray-100">
              <div
                class="relative flex items-center w-full lg:gap-1 text-nowrap lg:text-base text-[10px] leading-normal"
              >
                <component
                  :is="item.icon"
                  :class="activeMenuItemIndex === index ? 'text-gray-50 opacity-50' : ''"
                >
                </component>
                <div
                  :class="activeMenuItemIndex === index ? 'text-gray-350 ' : ''"
                  class="ml-[10px] text-black"
                >
                  {{ item.title }}
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
